import React from "react";
import PropTypes from "prop-types";

function AnimatedNavLink({ onClick, children, className = "" }) {     // ← add className
  return (
    <button
      onClick={onClick}
      className={`
                relative inline-block
               text-white
                transition-colors duration-300
                hover:text-[#E17564]
        
                after:content-['']
                after:absolute after:left-0 after:bottom-0
                after:block after:h-0.5
                after:w-0
                after:bg-[#E17564]
                after:origin-left after:transition-[width] after:duration-300
                hover:after:w-full
                ${className}                /* <- your extra classes come last */
              `}
    >
      {children}
    </button>
  );
}

AnimatedNavLink.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default AnimatedNavLink;
